/**
 * Type of all possible regions. Currently we only support region of Table
 */
// eslint-disable-next-line etc/no-const-enum
export var RegionType;
(function (RegionType) {
    /**
     * Region split by Table
     */
    RegionType[RegionType["Table"] = 0] = "Table";
})(RegionType || (RegionType = {}));
//# sourceMappingURL=RegionType.js.map